import { render, staticRenderFns } from "./ModalProgramMonitor.vue?vue&type=template&id=b6b65d94&scoped=true&"
import script from "./ModalProgramMonitor.vue?vue&type=script&lang=js&"
export * from "./ModalProgramMonitor.vue?vue&type=script&lang=js&"
import style0 from "./ModalProgramMonitor.vue?vue&type=style&index=0&id=b6b65d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b65d94",
  null
  
)

export default component.exports